<template>
  
</template>

<script>
  export default {
    name: 'Home',
    components: {
    },
    mounted: function(){
      // 访问首页时带有state，code查询参数 由openid server重定向回来 获取用户信息
      // if(this.$route.query.state && this.$route.query.code){
      //     this.$axios.get('/login_finish/', {
      //       params: {
      //         'code' : this.$route.query.code,
      //         'state' : this.$route.query.state,
      //       }
      //     })
      //     .then(function(response){
      //       console.log(response.data)
      //       localStorage['username'] = response.data.username
      //       localStorage['email'] = response.data.email
      //       that.$store.state.username = localStorage['username']
      //       that.$store.state.email = localStorage['email']
      //       that.$router.push('/')
      //     })
      //     .catch(function(error){
      //       alert(error)
      //     })
      // }
      // 首页暂无内容 直接跳转到填写页面
      // this.$router.push("/issue_create")
      // this.$router.go(0)
    },
  }
</script>
